import { useTranslation } from "react-i18next";
import { LocationGroup } from "./LocationGroup";
import type { WindowEntry, WindowEntryChip } from "./types";

type CommonProps = {
    groupedEntries: Array<[string, WindowEntry[]]>;
};

type SelectedWindowsListProps =
    | (CommonProps & { readonly: true })
    | (CommonProps & {
          readonly?: false;
          onRemoveChip: (entry: WindowEntry, chip: WindowEntryChip) => void;
      });

export function SelectedWindowsList(props: SelectedWindowsListProps) {
    const { t } = useTranslation();
    return (
        <div className="rounded-2xl border border-gray-200 bg-white overflow-hidden">
            <div className="px-5 py-4 border-b border-gray-100">
                <p className="text-xs font-semibold uppercase tracking-widest text-gray-400">
                    {t("confirmStep.selectedProducts")}
                </p>
            </div>

            {props.groupedEntries.map(([locationName, entries], groupIdx) =>
                props.readonly ? (
                    <LocationGroup
                        key={locationName}
                        locationName={locationName}
                        entries={entries}
                        isFirstGroup={groupIdx === 0}
                        readonly
                    />
                ) : (
                    <LocationGroup
                        key={locationName}
                        locationName={locationName}
                        entries={entries}
                        isFirstGroup={groupIdx === 0}
                        onRemoveChip={props.onRemoveChip}
                    />
                ),
            )}
        </div>
    );
}
